import React, { Component } from "react";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import Pdf from "../../assets/application.pdf";
import "./privacy.css";

class Privacy extends Component {
  componentDidMount() {
    window.scrollTo(0, 0);
  }

  render() {
    return (
      <React.Fragment>
        <Helmet>
          <title>個人情報保護方針 | 日本アドバンストリーダーズソフトウェア株式会社</title>
        </Helmet>
        <div className="privacy-container">
          <div className="container-box banner-container" id="privacy-banner-container">
            <div className="overlay"></div>
            <div className="row">
              <div className="col">
                <h1>個人情報保護方針</h1>
                <h3>PRIVACY POLICY</h3>
              </div>
            </div>
          </div>

          {/* Privacy Policy Section  */}
          <div className="container-box" id="privacy-policy-container">
            <div className="row row-title">
              <div className="col col-hr">
                <hr></hr>
              </div>
              <div className="col-12 col-md-6" id='privacy'>
                {/* <div className="col-8 col-md-6 col-lg-4" id='privacy'> */}
                <h2 className="text-blue text-bold">個人情報保護方針</h2>
                <h5>PRIVACY POLICY</h5>
              </div>
              <div className="col col-hr">
                <hr></hr>
              </div>
            </div>

            <div className="row row-content">
              <p>
                当社は、ソフトウェア開発・販売業務を営む企業として、個人情報保護への対応は
                重大な社会的責任であると認識しています。
                そして、本人の権利を保護するために、個人情報に関連する法規制等を遵守するとともに、以下に示す方針に基づき個人情報保護
                マネジメントシステムを構築します。
              </p>
              <p>
                <div className="indent-text">
                  1.
                  個人情報は、利用目的の範囲に限定して取得・利用・提供し、目的外利用をいたしません。
                  <br />
                  2.
                  個人情報への不正アクセス、紛失、破壊、改竄及び漏洩等のリスクに関して、合理的な安全対策を講じます。また、
                  漏洩、滅失又はき損の防止及び是正に関する対策を実施し個人情報に関するセキュリティー体制を継続的に向上させます。
                  <br />
                  3.
                  個人情報に関する法令、国が定める指針その他の規範を遵守します。
                  <br />
                  4.
                  個人情報保護マネジメントシステムを適時・適切に見直し、継続的な改善活動を行います。
                  <br />
                </div>
              </p>
              <p>
                本方針は、外部公開するとともに従業者に周知し、各自の教育、啓発に努め個人情報保護意識の高揚を図ります。
                <br />
                本方針並びに個人情報に関してのお問合せ・ご相談・苦情等は、日本アドバンストリーダーズソフトウェア株式会社内、
                ISMS管理責任者（TEL:　052-433-7796）迄、ご連絡をお願いします。
              </p>
              <p className="text-right text-blue">
                新規制定日：平成20年1月1日
                <br />
                最終改訂日：―
                <br />
                日本アドバンストリーダーズソフトウェア株式会社
                <br />
              </p>
            </div>
          </div>

          <div className="container-box" id="privacy-policy-container">
            <div className="row row-title">
              <div className="col col-hr">
                <hr></hr>
              </div>
              <div className="col-12 col-md-6" id='security'>
                <h2 className="text-blue text-bold">情報セキュリティー基本方針</h2>
                <h5>STANDARD POLICY ON INFORMATION SECURITY</h5>
              </div>
              <div className="col col-hr">
                <hr></hr>
              </div>
            </div>

            <div className="row row-content">
              <p>
                <span className="text-orange text-bold">1. 基本方針</span>
                <br />
                <div className="indent-text">
                  当社はソフトウェア開発・販売業務を営む企業として、お客様や関係者の皆様から高い信頼を獲得することを大切に考えています。
                  そのために、当社の事業に対する要求事項、法令、規制、契約上の要求事項、また組織のセキュリティ上の要求事項を従業員等ひとり
                  ひとりが十分に認識し行動いたします。「従業員等」とは、当社内にあって直接間接を問わず業務に従事している者、
                  並びに当社の情報資産にアクセスできる者です。（役員、従業員、アルバイト、契約社員、協力会社社員）。
                </div>
              </p>
              <p>
                <span className="text-orange text-bold">2. 適用範囲</span>
                <br />
                <div className="indent-text">
                  本基本方針は、全ての従業員等に適用します。
                </div>
              </p>
              <p>
                <span className="text-orange text-bold">3. 活動組織</span>
                <br />
                <div className="indent-text">
                  当社の情報セキュリティ活動を推進する情報セキュリティ管理責任者を任命します。
                  <br />
                  情報セキュリティ活動を運営する組織として、情報セキュリティ委員会を設置し、リスクアセスメントを実施して、
                  情報セキュリティ上のリスクの把握、管理策の適用、及び組織への普及と継続的改善を推進します。
                </div>
              </p>
              <p>
                <span className="text-orange text-bold">
                  4. 情報セキュリティ監視及び監査
                </span>
                <br />
                <div className="indent-text">
                  セキュリティを確保するため各部門のセキュリティ委員は、担当する部門のセキュリティ対策の実施状況を定常的に監視し、
                  計画された内部監査に対応してセキュリティの改善に努めます。
                </div>
              </p>
              <p>
                <span className="text-orange text-bold">
                  5. 情報セキュリティ教育の受講
                </span>
                <br />
                <div className="indent-text">
                  全ての従業員等は情報セキュリティに関する教育を受講します。
                </div>
              </p>
              <p>
                <span className="text-orange text-bold">6. 機密情報の保護</span>
                <br />
                <div className="indent-text">
                  当社の業務に関わる全ての従業員等は、社内規程に基づいて、機密情報の取り扱いに厳重な注意を払います。
                </div>
              </p>
              <p>
                <span className="text-orange text-bold">
                  7. 法令・規制・契約事項等の遵守
                </span>
                <br />
                <div className="indent-text">
                  事業推進上で適用される法令・規制・契約事項を、その都度、把握して遵守します。
                </div>
              </p>
              <p className="text-right text-blue">
                新規制定日：平成25年11月5日
                <br />
                最終改訂日：平成28年6月1日
                <br />
                日本アドバンストリーダーズソフトウェア株式会社
                <br />
              </p>
            </div>
          </div>

          <div className="container-box" id="privacy-policy-container">
            <div className="row row-title">
              <div className="col col-hr">
                <hr></hr>
              </div>
              <div className="col-12 col-md-6">
                <h2 className="text-blue text-bold">個人情報の利用目的</h2>
                <h5>PURPOSE OF USING PERSONAL INFORMATION</h5>
              </div>
              <div className="col col-hr">
                <hr></hr>
              </div>
            </div>

            <div className="row row-content">
              <p>
                当社は、事業活動において、個人情報を以下の目的のために利用します。
                <br />
                <br />
                <span className="content-header text-orange text-bold">
                  1.製品、サービスに関するお問合せ情報
                </span>
                <br />
                <div className="indent-text">
                  1.電話、電子メール、ダイレクトメールなど各種媒体による情報提供。
                  <br />
                  <div className="indent-text">
                    a)当社が取扱う製品・サービスに関する提案、その他の情報提供（カタログなどの送付を含みます）
                    <br />
                    b)当社が取扱う製品のサポート、メンテナンスに関する提案、その他の情報提供
                    <br />
                    c)キャンペーン、フェアー、催物に関する情報提供
                    <br />
                    d)アンケート・モニターに関する情報提供
                    <br />
                  </div>
                  2.当社の製品・サービスに関する改善または新しいサービスの開発。
                  <br />
                  3.個人を識別できない状態での各種統計資料の作成。
                  <br />
                  4.その他、お客様から同意を得た範囲内での利用。
                  <br />
                  5.上記の利用目的を達成するにあたり、秘密保持契約を締結したうえで、弊社の業務委託先または提携先に対して個人情報を開示する場合があります。
                  <br />
                </div>
              </p>
              <p>
                <span className="content-header text-orange text-bold">
                  2.リクルート情報
                </span>
                <br />
                <div className="indent-text">
                  1.採用選考における利用。
                  <br />
                  2.選考面接の案内および結果の通知。
                  <br />
                  3.内定式等の会社行事の案内。取得した個人情報は、採用選考から入社までのリクルート活動に限定して利用します。
                </div>
              </p>
              <p>
                <span className="content-header text-orange text-bold">
                  3.｢開示等の求め｣に基づくお客様の個人情報
                </span>
                <br />
                <div className="indent-text">
                  1.開示等の求めに適切に対応する為。
                </div>
              </p>
              <p>
                <span className="content-header text-orange text-bold">
                  4.名刺交換等で取得した個人情報
                </span>
                <br />
                <div className="indent-text">
                  1.業務上の連絡等に対応する為。
                  <br />
                  2.その他、お客様から同意を得た範囲内での利用。
                </div>
              </p>
            </div>
          </div>

          <div className="container-box" id="privacy-policy-container">
            <div className="row row-title">
              <div className="col col-hr">
                <hr></hr>
              </div>
              <div className="col-12 col-md-6">
                <h2 className="text-blue text-bold">個人情報の開示について</h2>
                <h5>DISCLOSURE OF PERSONAL INFORMATION</h5>
              </div>
              <div className="col col-hr">
                <hr></hr>
              </div>
            </div>

            <div className="row row-content">
              <p>
                当社では、個人情報をお預かりしたご本人様またはその代理人様から開示・変更・利用停止等の請求があった場合、
                合理的な期間および範囲で対応させていただきます。ただし、以下の場合は開示のご請求にお応えできません。
              </p>
              <p>
                <div className="indent-text">
                  <p>1.ご本人様の確認ができない場合 </p>
                  また、以下の場合には変更・利用停止などのご請求にお応えできない場合があります。
                  <br />
                  1.ご本人様の確認ができない場合
                  <br />
                  2.法令に違反することになる場合
                  <br />
                  3.第三者の生命、身体、財産その他の権利利益を害する恐れがある場合
                  <br />
                  4.弊社の業務の適正な実施に著しい支障を及ぼす恐れがある場合
                  <br />
                </div>
              </p>
              <p>
                <span className="content-header text-orange text-bold">
                  開示等の対象となる項目
                </span>
                <br />
                <div className="indent-text">
                  開示請求の対象となる情報は、弊社のデータベース、または検索可能な状態に整理された弊社の情報ファイルに保管されている個人情報です。
                </div>
              </p>
              <p>
                <span className="content-header text-orange text-bold">
                  開示等のご請求先
                </span>
                <br />
                <div className="indent-text">
                  開示等のご請求は、原則として書面で行っていただきます。以下の窓口まで当社所定の申請書に必要書類を添付の上、郵送によりご請求ください。
                </div>
              </p>
              <p>
                <div className="indent-text highlight-box">
                  〒450-0002 <br />
                  愛知県名古屋市中村区名駅3丁目11番22号 ＩＴ名駅ビル7階
                  <br />
                  日本アドバンストリーダーズソフトウェア株式会社
                  <br />
                  ISMS管理責任者
                  <br />
                  isms@nalsoft.co.jp <br />
                </div>
              </p>
              <p>
                <span className="content-header text-orange text-bold">
                  開示等のご請求にご使用いただく申請書等
                </span>
                <br />
                <div className="indent-text">
                  1.当社所定の申請書
                  <Link to={Pdf} target="blank" className="link-no-line">
                    「個人情報問い合わせ申請書」
                  </Link>
                  を印刷の上、ご使用ください。
                  <br />
                  2.ご本人確認のための書類（次の書類のいずれかのコピー）: <br />運転免許証（表・裏ともに）、パスポート、各種福祉手帳、
                  各種健康保険証、各種年金手帳、外国人記載証明書
                  <br />
                  3.代理人が請求される場合
                  <br />
                  法定代理人（親権者または成年後見人）の場合は、法定代理人であることを証明する書類。委任による代理人の場合は、
                  「委任状」および代理人の印鑑証明書
                </div>
              </p>
              <p>
                <span className="content-header text-orange text-bold">
                  開示等のご請求に必要な手数料およびその徴収方法
                </span>
                <br />
                <div className="indent-text">
                  1回の申請ごとに800円が必要です。800円分の郵便為替を申請書類に同封してください。
                </div>
              </p>
              <p>
                ※
                手数料が不足していた場合、および手数料が同封されていなかった場合は、その旨ご連絡差し上げます。
                <br />
                ご連絡後、所定の期間内にお支払いがない場合は、開示のご請求がなかったものとして対応させていただきます。
              </p>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default Privacy;
